import { Link } from "react-router-dom";
import "../App.css";

function Banner({
  message,
  title,
  linkText,
  linkTo,
  onDismiss,
  backgroundColor,
  position = "bottom",
}) {
  return (
    <div
      className={`banner-wrapper banner-wrapper--${position}`}
      style={backgroundColor ? { background: backgroundColor } : undefined}
    >
      <div className="banner-inner">
        <div className="banner-icon">🍽️</div>

        <div className="banner-content">
          {title && <strong className="banner-title">{title}</strong>}
          <p>{message}</p>
        </div>

        <div className="banner-actions">
          {linkText && linkTo && (
            <Link to={linkTo} className="banner-link">
              {linkText}
            </Link>
          )}
          {onDismiss && (
            <button className="banner-dismiss" onClick={onDismiss}>
              ×
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Banner;
